import axios from "axios";
import { axiosConfig } from "../../config/index";
import {
  SITE_ADDED,
  SITE_FETCHED,
  SITE_EDITED,
  SET_SITE,
  SITE_DELETED,
  LOCATION_FETCHED,
  SITE_DOOR,
} from "../types";

/**
 * Adds a new security site to the system.
 */
export const addSite = (siteinfo: any) => (dispatch: any) => {
  const addsiteURL = `/api/sites/addsite`;
  return new Promise((resolve, reject) => {
    axios
      .post(addsiteURL, siteinfo, axiosConfig)
      .then((res) => {
        dispatch({
          type: SITE_ADDED,
          addedsite: res.data,
        });
        dispatch(getAllSites());
        resolve(true);
      })
      .catch((err) => {
        return reject(err?.response?.data);
      });
  });
};

/**
 * Fetches all active security sites.
 */
export const getAllSites = () => (dispatch: any) => {
  axios
    .get(`/api/sites/getallsite`, axiosConfig)
    .then((res) => {
      dispatch({
        type: SITE_FETCHED,
        siteData: res.data,
      });
    })
    .catch((err) => {
      console.error(err);
    });
};

/**
 * Fetches all locations.
 */
export const getAllLocations = () => (dispatch: any) => {
  axios
    .get(`/api/sites/getalllocation`, axiosConfig)
    .then((res) => {
      dispatch({
        type: LOCATION_FETCHED,
        locationData: res.data,
      });
    })
    .catch((err) => {
      console.error(err);
    });
};

/**
 * Fetches door-to-site relationships.
 */
export const getSiteDoor = () => (dispatch: any) => {
  axios
    .get(`/api/sites/doorsite`, axiosConfig)
    .then((res) => {
      dispatch({
        type: SITE_DOOR,
        siteDoor: res.data,
      });
    })
    .catch((err) => {
      console.error(err);
    });
};

/**
 * Updates details of an existing site.
 */
export const editSite = (siteId: any, editedsiteData: any) => (
  dispatch: any
) => {
  return new Promise((resolve, reject) => {
    axios
      .put(
        `/api/sites/updatesite/${siteId}`,
        editedsiteData,
        axiosConfig
      )
      .then((res) => {
        dispatch({
          type: SITE_EDITED,
        });
        dispatch(getAllSites());
        resolve(res.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err?.response?.data || err);
      });
  });
};

/**
 * Sets the active site in state.
 */
export const setSite = (singleSite: any) => {
  return {
    type: SET_SITE,
    singleSite,
  };
};

/**
 * Archives/deletes a site by ID.
 */
export const deleteSite = (siteId: any) => (dispatch: any) => {
  return new Promise((resolve, reject) => {
    axios
      .put(`/api/sites/deletesite/${siteId}`, {}, axiosConfig)
      .then((res) => {
        dispatch({
          type: SITE_DELETED,
        });
        dispatch(getAllSites());
        resolve(res.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err?.response?.data || err);
      });
  });
};
